import dayjs from 'dayjs'
import { ReactElement } from 'react'
import { GroupBase, StylesConfig } from 'react-select'

import {
  HouseAvailabilityGlobalOutputDto,
  HouseAvailabilityGlobalStateEnum,
  HouseAvailabilityUnionOutputDto,
} from '../../../../../../../lib/graphql'

export const bigCalendarHeaderStyle = (): StylesConfig<
  any,
  true,
  GroupBase<unknown>
> => ({
  control: (styles, { menuIsOpen }) => ({
    ...styles,
    background: 'var(--brand-400)',
    color: 'var(--black)',
    cursor: 'pointer',
    border: `1px solid ${menuIsOpen ? 'var(--black)' : 'transparent'}`,
    boxShadow: 'none',
    padding: '0 8px 0 16px',
    borderRadius: '6px',
    width: '170px',
    '&:hover': {
      border: '1px solid var(--black)',
    },
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 10,
    padding: 0,
    width: '170px',
    right: 'auto',
    marginTop: '5px',
  }),
  option: (_, { isSelected }: { isSelected: boolean }) => {
    return {
      fontSize: '14px',
      cursor: 'pointer',
      padding: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: `${!isSelected ? 'black' : 'var(--grey-700)'}`,
      '&:hover': {
        color: 'var(--black)',
      },
      '&:not(:last-child)': {
        borderBottom: '1px solid var(--border)',
      },
    }
  },
  placeholder: (styles) => ({
    ...styles,
    ...{ fontSize: '13px', opacity: 0.5, color: 'var(--black)', margin: 0 },
  }),
  singleValue: (styles) => ({
    ...styles,
    ...{ fontSize: '14px', color: 'var(--black)' },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  valueContainer: (styles) => ({
    ...styles,
    ...{ padding: 0, flex: 'none' },
  }),
})

type BigCalendarCellWrapperClassNamesProps = {
  availability: HouseAvailabilityUnionOutputDto | null
  cellDate: Date
  children: JSX.Element
  isPast: boolean
}
export const bigCalendarCellWrapperClassNames = ({
  availability,
  cellDate,
  children,
  isPast,
}: BigCalendarCellWrapperClassNamesProps): string => {
  const rbcClassName = (children as ReactElement).props.className

  const isLastDay = dayjs(cellDate).isSame(
    dayjs(cellDate).endOf('month'),
    'day',
  )

  const isICalendar =
    availability?.__typename === 'HouseAvailabilityICalendarOutputDto'

  const isFullyBookedOrLocked =
    availability?.__typename === 'HouseAvailabilityGlobalOutputDto' &&
    (
      [
        'corporateEvening',
        'nightlyTrip',
        'studyDay',
      ] as (keyof HouseAvailabilityGlobalOutputDto)[]
    ).every(
      (key) =>
        availability?.[key]?.state !== HouseAvailabilityGlobalStateEnum.FREE,
    )

  const offRangeClass = isPast ? 'rbc-off-range-past' : ''
  const iCalendarClass = !isPast && isICalendar ? 'rbc-icalendar' : ''
  const lastDayClass = isLastDay ? 'rbc-last-day' : ''
  const selectableClass =
    !isICalendar && !isPast && !isFullyBookedOrLocked
      ? 'rbc-select-available'
      : ''
  const fullyBookedOrLockedClass = isFullyBookedOrLocked
    ? 'rbc-fully-booked-locked'
    : ''

  const rbcClassNames = `${rbcClassName} ${iCalendarClass} ${lastDayClass} ${offRangeClass} ${selectableClass} ${fullyBookedOrLockedClass}`

  return `${rbcClassNames} p-4`
}
